import React from 'react';
import { connect } from 'react-redux';
import { setScreen, setConfiguration, setAllConsentSwitch, setAllObjectConsentSwitch } from '../../redux/actions';
import './Buttons.scss';
import { sendPostMessage, sendPostMessageNoTracking } from '../../scripts/PostMessage';
import { switchScreenButton } from '../../scripts/lib/handlers';

const Buttons = props => {
    const { configuration } = props;

    const modifyConfigurationHandler = configuration => {
        switchScreenButton(configuration);
        props.setAllConsentSwitch(false);
        props.setAllObjectConsentSwitch(false);
    };

    const cols = {
        1:12,
        2:6,
        3:4
    };
    //debugger;
    let curCols = 1;
    if(props.currentScreen === 1){
        curCols++;
    }
    if(configuration && configuration.domesticPolicy){
        curCols++;
    }

    const renderConsentButton = () => {
        switch (props.currentScreen) {
            case 2:
                return <div onClick={sendPostMessage} className={`btn green col-${cols[curCols]} ${configuration.domesticPolicy ? 'domestic-btn':''}`}>{props.currentLanguage.text.consentButtonSettingsScreen}</div>
            default:
                return <div onClick={sendPostMessage} className={`btn green col-${cols[curCols]} ${configuration.domesticPolicy ? 'domestic-btn':''}`}>{props.currentLanguage.text.consentButtonInformationScreen}</div>
        }
    };

    if (configuration && configuration.vendorList) {
        return (
            <div id="buttons" className="row">
                {props.currentScreen === 1 ? <div onClick={() => modifyConfigurationHandler(configuration)} className={`btn amber col-${cols[curCols]} ${configuration.domesticPolicy ? 'domestic-btn':''}`}>{props.currentLanguage.text.settingsButton}</div> : null} 
                {configuration.domesticPolicy && 
                    <div onClick={sendPostMessageNoTracking} className={`btn amber col-${cols[curCols]} ${configuration.domesticPolicy ? 'domestic-btn':''}`}>{props.currentLanguage.text.continueNoTrackingButton ? props.currentLanguage.text.continueNoTrackingButton : 'Continue without tracking'}</div> 
                }
                {renderConsentButton()}
            </div>
        )
    } else {
        return (
            <div id="buttons" className="row">
                <div className={`btn amber col-${cols[curCols]}`}>Loading configuration...</div>
            </div>
        )
    }
    
};

const mapStateToProps = state => {
    return {...state};
}

export default connect(mapStateToProps,{setScreen, setConfiguration,setAllConsentSwitch,setAllObjectConsentSwitch})(Buttons);